import React from 'react';

interface InfoboxResultProps {
  title: string;
  description: string;
  attributes: Record<string, any>;
  category: string;
}

const InfoboxResult: React.FC<InfoboxResultProps> = ({ title, description, attributes, category }) => {
  const data = {
    title,
    description,
    attributes,
    category,
  };

  return (
    <div className="w-full overflow-auto">
      <pre className="text-sm text-[var(--rhea-text-secondary)]">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};

export default InfoboxResult; 